import axios from 'axios'
import type { AxiosInstance } from 'axios'

import { attachLanguageInterceptor } from './language-interceptor'
import { attachRefreshInterceptor } from './refresh-interceptor'
import { env } from '../lib/env'
import { logApiRequest, logApiResponse, logError } from '../sso/utils/sso-logger'

/**
 * Adamo suite API (cookies). Same role as adamo-id-front-end `src/api/adamo-api.ts`.
 */
export const adamoApi: AxiosInstance = axios.create({
  baseURL: env.REACT_APP_ADAMO_API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

adamoApi.interceptors.request.use((config) => {
  const method = config.method?.toUpperCase() ?? 'GET'
  const url = `${config.baseURL ?? ''}${config.url ?? ''}`
  logApiRequest(method, url, {
    withCredentials: config.withCredentials,
    params: config.params
  })
  return config
})

adamoApi.interceptors.response.use(
  (response) => {
    const method = response.config.method?.toUpperCase() ?? 'GET'
    const url = `${response.config.baseURL ?? ''}${response.config.url ?? ''}`
    logApiResponse(method, url, response.status, {
      message: response.data?.message
    })
    return response
  },
  (error) => {
    const cfg = error.config
    const method = cfg?.method?.toUpperCase() ?? 'GET'
    const url = `${cfg?.baseURL ?? ''}${cfg?.url ?? ''}`
    logError(`API error ${method} ${url}`, error, {
      status: error.response?.status,
      responseData: error.response?.data,
      errors: error.response?.data?.errors
    })
    return Promise.reject(error)
  }
)

attachLanguageInterceptor(adamoApi)
attachRefreshInterceptor(adamoApi)
